const dataTable = '';

document.addEventListener('turbolinks:before-cache', () => {
  if (dataTable != null) {
    dataTable.destroy();
    dataTable = null;
  }
});
